/**
 * Video.js plugin "signLanguage"
 *
 * The plugin offers an alternative video with sign language.
 *
 * @function signLanguage
 * @param
 */

const pluginSignLanguage = videojs => {
  videojs.addLanguage('de', {
    'Sign language on': 'Video in Gebärdensprache an',
    'Sign language off': 'Video in Gebärdensprache aus',
  });

  videojs.registerPlugin('signLanguage', function (player) {
    player.ready(() => {
      // Prevent doubled rendering
      if (player.el_.querySelector('.vjs-sign-language')) return;

      // Return if no social share data is present.
      if (!player.el_.dataset || !player.el_.dataset.signLanguage) return;

      const slData = JSON.parse(player.el_.dataset.signLanguage);
      const slSources = [];
      let sources = player.currentSources();
      let currentTime = 0;
      let currentPlaybackRate = 0;

      for (const [label, source] of Object.entries(slData)) {
        let fileType = source.split('.');
        fileType = fileType[fileType.length - 1];

        slSources.push({
          label,
          src: source,
          type: `video/${fileType}`,
          selected: false,
        });
      }

      let isActive = false;
      let controlBarButton;

      // Add `selected` prop to initial player sources
      sources.forEach(source => {
        source.selected = source.src === player.src();
      });
      player.src(sources);

      const createControlbarButton = () => {
        controlBarButton = player.controlBar.addChild('button');
        controlBarButton.controlText(player.localize('Sign language off'));
        controlBarButton.el_.classList.add('vjs-sign-language');

        controlBarButton.on('click', toggle);
        controlBarButton.on('touchend', toggle);
      };

      const toggle = () => {
        isActive = !isActive;

        if (!isActive) {
          controlBarButton.controlText(player.localize('Sign language on'));
          controlBarButton.el_.classList.remove('vjs-sign-language--on');
          switchSrc();
          return;
        }

        controlBarButton.controlText(player.localize('Sign language off'));
        controlBarButton.el_.classList.add('vjs-sign-language--on');
        switchSrc();
      };

      const switchSrc = () => {
        const isPaused = player.paused();
        let currentLabel;
        currentTime = player.currentTime();
        currentPlaybackRate = player.playbackRate();

        if (isActive) {
          sources = player.currentSources();
          currentLabel = sources.filter(source => source.selected)[0].label;
          slSources.forEach(source => {
            source.selected = false;
            if (source.label === currentLabel) source.selected = true;
          });
        }

        player.src(isActive ? slSources : sources);
        player.currentTime(currentTime);
        player.playbackRate(currentPlaybackRate);

        player.play().then(() => {
          if (isPaused) player.pause();
        });
        controlBarButton.focus();
      };

      createControlbarButton();
    });
  });
};

export { pluginSignLanguage };
